import _ from "lodash";
import React from "react";
import SkeletonLoader from "UIComponents/SkeletonLoader";
import classes from "./CourseFeedSkeletonLoader.scss";

const CourseFeedSkeletonLoader = props => {
  const { dummyCourseCount = 4, showSubtitle = true } = props;

  return _.times(dummyCourseCount, index => {
    return (
      <div className={classes.container} key={index}>
        <SkeletonLoader variant="rounded" height="40px" width="40px" />
        <div className={classes.rightContainer}>
          <SkeletonLoader variant="rounded" height="14px" width="155px" />
          {showSubtitle ? (
            <SkeletonLoader variant="rounded" height="10px" width="115px" />
          ) : null}
        </div>
      </div>
    );
  });
};

export default CourseFeedSkeletonLoader;
